"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Svg_1 = require("./Svg");
const Path_1 = require("./Svg/Path");
const CheckboxOutline = ({ color = 'primary', ...rest }) => (React.createElement(Svg_1.default, Object.assign({}, rest),
    React.createElement(Path_1.default, { d: "M19 5v14H5V5h14m2-2H3v18h18V3z", color: color })));
exports.default = CheckboxOutline;
